// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/queue/pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/queue/loading_info_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/queue/blue_separator.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/queue/cancel_btn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/queue/news_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/queue/news_title_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@assets/queue/readmore_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queue-container {
    display: flex;
    flex-flow: column;
    align-items: center;    
  }
  
  .queue-body {
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 80vw;
    height: 24vw;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
  }
  
  .queue-info {
    width: 30vw;
    height: 20vw;
    position: relative;
  }
  
  .queue-spinner {
    position: absolute;
    top: 2.5vw;
    left: 1vw;
  }
  
  .queue-spinner-centered {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  
  .queue-spinner-loader {
    width: 14vw;
    height: 14vw;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    background: linear-gradient(0deg, transparent 33%, #f5b70e 100%);
    box-sizing: border-box;
    animation: rotation 2s linear infinite;
  }
  
  .queue-spinner-loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(14vw - 1vw);
    height: calc(14vw - 1vw);
    border-radius: 50%;
    background: #080c15;
  }
  
  @keyframes rotation {
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
  }
  
  .queue-count {
    position: absolute;
    top: 3.45vw;
    left: 2vw;
    width: 12vw;
    height: 12vw;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  @keyframes progress {
    0% { --percentage: 0; }
    100% { --percentage: var(--value); }
  }
  
  @property --percentage {
    syntax: '<number>';
    inherits: true;
    initial-value: 20;
  }
  
  [role="progressbar"] {
    --percentage: var(--value);
    --primary: #369;
    --secondary: #adf;
    --size: 12vw;
    width: var(--size);
    aspect-ratio: 1;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    display: grid;
    place-items: center;
  }
  
  [role="progressbar"]::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: conic-gradient(cyan calc(var(--percentage) * 1%), rgb(66, 66, 66) 0);
    mask: radial-gradient(white 55%, transparent 0);
    mask-mode: alpha;
    -webkit-mask: radial-gradient(#0000 68%, black 0);
    -webkit-mask-mode: alpha;
  }
  
  .queue-count-number {
    font-size: 3.2vw;
    font-weight: 900;
    color: #f5b70e;
    text-align: center;
  }
  
  .queue-count-text {
    font-size: 1.4vw;
    color: white;
  }
  
  .queue-detail {
    position: absolute;
    top: 2vw;
    left: 7.5vw;
    width: 21vw;
    height: 16vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    padding: 0 0.55vw;
  }
  
  .queue-detail > div {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .queue-detail-header {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 0.5vw;
  }
  
  .queue-detail-btn {
    font-size: 1vw;
    color: white;
    background-color: black;
    width: 7vw;
    height: 2.5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .active {
    background-color: #252b36;
    border: 1px solid goldenrod;
  }
  
  .queue-detail-body {
    position: absolute;
    top: 4.2vw;
    left: 10vw;
    font-family: 'Kim';
  }
  
  .queue-detail-body > div {
    margin: 0.1vw 0 0.5vw;
    padding-bottom: 5px;
  }
  
  .queue-detail-body > div:not(:last-child) {
    border-bottom: 1px solid transparent;
    border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    border-image-slice: 1;
    border-image-repeat: repeat;
  }
  
  .queue-detail-body > div > div:first-child {
    font-size: 0.8vw;
    line-height: 1vw;
    color: white;
  }
  
  .queue-detail-body > div > div:last-child {
    font-size: 1vw;
    line-height: 1vw;
    color: white;
    display: flex;
    align-items: center;
  }
  
  .queue-detail-body > div > div:last-child > div > img {
    width: 1vw;
    height: 1vw;
    margin-right: 4px;
  }
  
  .queue-detail-footer {
    position: absolute;
    bottom: 0px;
    right: -0.5vw;
    width: 16vw;
    height: 3vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    padding-left: 0.75vw;
    padding-bottom: 0.65vw;
    cursor: pointer;
  }
  
  .queue-footer-exit {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .queue-footer-exit > img {
    width: 1.2vw;
    height: 1.2vw;
  }
  
  .queue-footer-text {
    text-align: center;
    margin-left: 3vw;
    font-family: Tahoma;
    font-size: 0.9vw;
    color: white;
  }
  
  .queue-detail-footer:hover .queue-footer-text {
    color: cyan;
  }
  
  .queue-detail-arrow {
    position: absolute;
    top: 7vw;
    left: 8.15vw;
  }
  
  .queue-detail-arrow > img {
    width: 0.6vw;
    height: auto;
  }
  
  .queue-text {
    position: absolute;
    top: 18.75vw;
    width: 100%;
    font-size: 1.2vw;
    font-family: 'Kim';
    text-align: center;
    color: white;
  }
  
  .queue-news {
    width: 100vw;
    display: flex;
    justify-content: center;
  }
  
  .queue-news-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    width: 23vw;
    height: 9.2vw;
    padding: 0.6vw 0.8vw 1vw;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    font-family: 'Kim';
  }
  
  .queue-news-content {
    color: white;
    padding: 0.5vw 1vw;
    overflow: hidden;
    height: 4vw;
    font-size: 0.8vw;
  }
  
  .queue-news-title {
    width: 100%;
    height: 2vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    font-size: 0.9vw;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .queue-news-date {
    font-size: 0.75vw;
    min-width: 4vw;
  }
  
  .queue-news-readmore {
    width: 21.4vw;
    height: 2vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-position: center;
    padding-left: 1vw;
    padding-right: 1vw;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: white;
    font-size: 0.75vw;
    cursor: pointer;
  }
  
  .queue-btns {
    margin-top: 0.5vw;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
  }
  
  .queue-btns > a > div {
    width: 2.5vw;
    height: 2.5vw;
    cursor: pointer;
  }
  
  .queue-btns > a > div > img {
    width: 100%;
    height: 100%;
  }
  
  .btn-x {
    margin-right: 0.25vw;
  }
  
  /* Lobby mode specific styles */
  .lobby-mode .queue-detail-footer {
    position: static;
    margin: 20px auto 0;
  }
  
  .lobby-mode .queue-text {
    position: static;
    margin-top: 20px;
  }
  
  .lobby-info-text {
    text-align: center;
    color: #ccc;
    margin-top: 20px;
    font-size: 0.9vw;
  }
  
  .lobby-info-text p {
    margin: 5px 0;
  }
  
  .cancel-game-link {
    text-decoration: none;
  }`, "",{"version":3,"sources":["webpack://./src/style/QueuePage.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,yDAAkD;IAClD,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gEAAgE;IAChE,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,KAAK,wBAAwB;IAC7B,OAAO,0BAA0B;EACnC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,KAAK,eAAe,EAAE;IACtB,OAAO,0BAA0B,EAAE;EACrC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gFAAgF;IAChF,+CAA+C;IAC/C,gBAAgB;IAChB,iDAAiD;IACjD,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAA0D;IAC1D,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,4DAA4D;IAC5D,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,WAAW;IACX,yDAAwD;IACxD,wBAAwB;IACxB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yDAAkD;IAClD,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;IAC5B,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yDAAwD;IACxD,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,yDAAsD;IACtD,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA,+BAA+B;EAC/B;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB","sourcesContent":[".queue-container {\n    display: flex;\n    flex-flow: column;\n    align-items: center;    \n  }\n  \n  .queue-body {\n    display: inline-block;\n    background-image: url('@assets/queue/pattern.png');\n    width: 80vw;\n    height: 24vw;\n    background-size: contain;\n    background-position: bottom;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .queue-info {\n    width: 30vw;\n    height: 20vw;\n    position: relative;\n  }\n  \n  .queue-spinner {\n    position: absolute;\n    top: 2.5vw;\n    left: 1vw;\n  }\n  \n  .queue-spinner-centered {\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n  }\n  \n  .queue-spinner-loader {\n    width: 14vw;\n    height: 14vw;\n    border-radius: 50%;\n    display: inline-block;\n    position: relative;\n    background: linear-gradient(0deg, transparent 33%, #f5b70e 100%);\n    box-sizing: border-box;\n    animation: rotation 2s linear infinite;\n  }\n  \n  .queue-spinner-loader::after {\n    content: '';\n    box-sizing: border-box;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: calc(14vw - 1vw);\n    height: calc(14vw - 1vw);\n    border-radius: 50%;\n    background: #080c15;\n  }\n  \n  @keyframes rotation {\n    0% { transform: rotate(0deg) }\n    100% { transform: rotate(360deg) }\n  }\n  \n  .queue-count {\n    position: absolute;\n    top: 3.45vw;\n    left: 2vw;\n    width: 12vw;\n    height: 12vw;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  @keyframes progress {\n    0% { --percentage: 0; }\n    100% { --percentage: var(--value); }\n  }\n  \n  @property --percentage {\n    syntax: '<number>';\n    inherits: true;\n    initial-value: 20;\n  }\n  \n  [role=\"progressbar\"] {\n    --percentage: var(--value);\n    --primary: #369;\n    --secondary: #adf;\n    --size: 12vw;\n    width: var(--size);\n    aspect-ratio: 1;\n    border-radius: 50%;\n    position: relative;\n    overflow: hidden;\n    display: grid;\n    place-items: center;\n  }\n  \n  [role=\"progressbar\"]::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: conic-gradient(cyan calc(var(--percentage) * 1%), rgb(66, 66, 66) 0);\n    mask: radial-gradient(white 55%, transparent 0);\n    mask-mode: alpha;\n    -webkit-mask: radial-gradient(#0000 68%, black 0);\n    -webkit-mask-mode: alpha;\n  }\n  \n  .queue-count-number {\n    font-size: 3.2vw;\n    font-weight: 900;\n    color: #f5b70e;\n    text-align: center;\n  }\n  \n  .queue-count-text {\n    font-size: 1.4vw;\n    color: white;\n  }\n  \n  .queue-detail {\n    position: absolute;\n    top: 2vw;\n    left: 7.5vw;\n    width: 21vw;\n    height: 16vw;\n    background-image: url('@assets/queue/loading_info_bg.png');\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    padding: 0 0.55vw;\n  }\n  \n  .queue-detail > div {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .queue-detail-header {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    margin-bottom: 0.5vw;\n  }\n  \n  .queue-detail-btn {\n    font-size: 1vw;\n    color: white;\n    background-color: black;\n    width: 7vw;\n    height: 2.5vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .active {\n    background-color: #252b36;\n    border: 1px solid goldenrod;\n  }\n  \n  .queue-detail-body {\n    position: absolute;\n    top: 4.2vw;\n    left: 10vw;\n    font-family: 'Kim';\n  }\n  \n  .queue-detail-body > div {\n    margin: 0.1vw 0 0.5vw;\n    padding-bottom: 5px;\n  }\n  \n  .queue-detail-body > div:not(:last-child) {\n    border-bottom: 1px solid transparent;\n    border-image-source: url('@assets/queue/blue_separator.png');\n    border-image-slice: 1;\n    border-image-repeat: repeat;\n  }\n  \n  .queue-detail-body > div > div:first-child {\n    font-size: 0.8vw;\n    line-height: 1vw;\n    color: white;\n  }\n  \n  .queue-detail-body > div > div:last-child {\n    font-size: 1vw;\n    line-height: 1vw;\n    color: white;\n    display: flex;\n    align-items: center;\n  }\n  \n  .queue-detail-body > div > div:last-child > div > img {\n    width: 1vw;\n    height: 1vw;\n    margin-right: 4px;\n  }\n  \n  .queue-detail-footer {\n    position: absolute;\n    bottom: 0px;\n    right: -0.5vw;\n    width: 16vw;\n    height: 3vw;\n    background-image: url('@assets/queue/cancel_btn_bg.png');\n    background-size: contain;\n    background-repeat: no-repeat;\n    display: flex;\n    align-items: center;\n    padding-left: 0.75vw;\n    padding-bottom: 0.65vw;\n    cursor: pointer;\n  }\n  \n  .queue-footer-exit {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .queue-footer-exit > img {\n    width: 1.2vw;\n    height: 1.2vw;\n  }\n  \n  .queue-footer-text {\n    text-align: center;\n    margin-left: 3vw;\n    font-family: Tahoma;\n    font-size: 0.9vw;\n    color: white;\n  }\n  \n  .queue-detail-footer:hover .queue-footer-text {\n    color: cyan;\n  }\n  \n  .queue-detail-arrow {\n    position: absolute;\n    top: 7vw;\n    left: 8.15vw;\n  }\n  \n  .queue-detail-arrow > img {\n    width: 0.6vw;\n    height: auto;\n  }\n  \n  .queue-text {\n    position: absolute;\n    top: 18.75vw;\n    width: 100%;\n    font-size: 1.2vw;\n    font-family: 'Kim';\n    text-align: center;\n    color: white;\n  }\n  \n  .queue-news {\n    width: 100vw;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .queue-news-container {\n    background-image: url('@assets/queue/news_bg.png');\n    width: 23vw;\n    height: 9.2vw;\n    padding: 0.6vw 0.8vw 1vw;\n    background-size: contain;\n    background-repeat: no-repeat;\n    display: flex;\n    flex-flow: column;\n    justify-content: space-between;\n    font-family: 'Kim';\n  }\n  \n  .queue-news-content {\n    color: white;\n    padding: 0.5vw 1vw;\n    overflow: hidden;\n    height: 4vw;\n    font-size: 0.8vw;\n  }\n  \n  .queue-news-title {\n    width: 100%;\n    height: 2vw;\n    background-image: url('@assets/queue/news_title_bg.png');\n    font-size: 0.9vw;\n    padding: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .queue-news-date {\n    font-size: 0.75vw;\n    min-width: 4vw;\n  }\n  \n  .queue-news-readmore {\n    width: 21.4vw;\n    height: 2vw;\n    background-image: url('@assets/queue/readmore_bg.png');\n    background-position: center;\n    padding-left: 1vw;\n    padding-right: 1vw;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    color: white;\n    font-size: 0.75vw;\n    cursor: pointer;\n  }\n  \n  .queue-btns {\n    margin-top: 0.5vw;\n    margin-bottom: 0;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .queue-btns > a > div {\n    width: 2.5vw;\n    height: 2.5vw;\n    cursor: pointer;\n  }\n  \n  .queue-btns > a > div > img {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .btn-x {\n    margin-right: 0.25vw;\n  }\n  \n  /* Lobby mode specific styles */\n  .lobby-mode .queue-detail-footer {\n    position: static;\n    margin: 20px auto 0;\n  }\n  \n  .lobby-mode .queue-text {\n    position: static;\n    margin-top: 20px;\n  }\n  \n  .lobby-info-text {\n    text-align: center;\n    color: #ccc;\n    margin-top: 20px;\n    font-size: 0.9vw;\n  }\n  \n  .lobby-info-text p {\n    margin: 5px 0;\n  }\n  \n  .cancel-game-link {\n    text-decoration: none;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
